import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="py-6 container">
        <div className="steps mt-6 mb-4 hide-on-tablet">
          <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
            <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
              <div className="ant-steps-item-container">
                <div className="ant-steps-item-tail"></div>
                <div className="ant-steps-item-icon"><span className="ant-steps-icon">1</span></div>
                <div className="ant-steps-item-content">
                  <div className="ant-steps-item-title">Before you start</div>
                  <div className="ant-steps-item-description">Input your awesome title and choose the currency</div>
                </div>
              </div>
            </div>
            <div className="ant-steps-item ant-steps-item-wait">
              <div className="ant-steps-item-container">
                <div className="ant-steps-item-tail"></div>
                <div className="ant-steps-item-icon"><span className="ant-steps-icon">2</span></div>
                <div className="ant-steps-item-content">
                  <div className="ant-steps-item-title">Private Sale</div>
                  <div className="ant-steps-item-description">Enter the launchpad information that you want to raise , that should be enter all details about your presale
                  </div>
                </div>
              </div>
            </div>
            <div className="ant-steps-item ant-steps-item-wait">
              <div className="ant-steps-item-container">
                <div className="ant-steps-item-tail"></div>
                <div className="ant-steps-item-icon"><span className="ant-steps-icon">3</span></div>
                <div className="ant-steps-item-content">
                  <div className="ant-steps-item-title">Add Additional Info</div>
                  <div className="ant-steps-item-description">Let people know who you are</div>
                </div>
              </div>
            </div>
            <div className="ant-steps-item ant-steps-item-wait">
              <div className="ant-steps-item-container">
                <div className="ant-steps-item-tail"></div>
                <div className="ant-steps-item-icon"><span className="ant-steps-icon">4</span></div>
                <div className="ant-steps-item-content">
                  <div className="ant-steps-item-title">Finish</div>
                  <div className="ant-steps-item-description">Review your information</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ height: "24px" }}></div>
        <div className="ant-card ant-card-bordered">
          <div className="ant-card-body">
            <form>
              <p className="has-text-primary is-size-7">(*) is required field.</p>
              <div className="columns field">
                <div className="column"><label className="label" for="title">Title<sup
                  className="has-text-danger">*</sup></label>
                  <div className="control"><input className="input" type="text" placeholder="Ex: This is my private sale" id="title" name="title" value="" />
                    <p className="help is-info">Pool creation fee: 1 BNB</p>
                  </div>
                </div>
              </div>
              <div className="field">
                <div className="is-flex is-align-items-center mb-2 flex-wrap">
                  <div className="is-flex-grow-1 mr-4"><label className="label" for="tokenAddress">Currency</label></div>
                </div>
                <div className="control">
                  <div className="ant-radio-group ant-radio-group-outline">
                    <div className="ant-space ant-space-vertical" style={{ gap: "8px" }}>
                      <div className="ant-space-item"><label className="ant-radio-wrapper ant-radio-wrapper-checked"><span
                        className="ant-radio ant-radio-checked"><input
                          name="currency" type="radio" className="ant-radio-input"
                          value="0x0000000000000000000000000000000000000000"
                          checked="" /><span
                            className="ant-radio-inner"></span></span><span>BNB</span></label>
                      </div>
                      <div className="ant-space-item"><label className="ant-radio-wrapper"><span
                        className="ant-radio"><input name="currency" type="radio"
                          className="ant-radio-input"
                          value="0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56" /><span
                            className="ant-radio-inner"></span></span><span>BUSD</span></label>
                      </div>
                      <div className="ant-space-item"><label className="ant-radio-wrapper"><span
                        className="ant-radio"><input name="currency" type="radio"
                          className="ant-radio-input"
                          value="0x55d398326f99059fF775485246999027B3197955" /><span
                            className="ant-radio-inner"></span></span><span>USDT</span></label>
                      </div>
                      <div className="ant-space-item"><label className="ant-radio-wrapper"><span
                        className="ant-radio"><input name="currency" type="radio"
                          className="ant-radio-input"
                          value="0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d" /><span
                            className="ant-radio-inner"></span></span><span>USDC</span></label>
                      </div>
                    </div>
                  </div>
                  <p className="help is-info">Users will pay with BNB for your token</p>
                </div>
              </div>
              <div className="has-text-centered"><button type="button" className="ant-btn ant-btn-primary" disabled=""><span>Next</span></button></div>
            </form>
          </div>
        </div>
      </div>


    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
